import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svgs/chevron-left.svg'


const _withScopeId = n => (_pushScopeId("data-v-669df5a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card h-100 w-100 kanban-menu rounded-0 border-0" }
const _hoisted_2 = { class: "card-body p-0 border-0" }
const _hoisted_3 = { class: "d-flex p-2 justify-content-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-2" }, null, -1))
const _hoisted_5 = { class: "your-boards my-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center ps-3 p-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Your boards "),
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus add-board" })
], -1))
const _hoisted_7 = { class: "your-boards__list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_workspace_title = _resolveComponent("workspace-title")!
  const _component_kanban_list = _resolveComponent("kanban-list")!
  const _component_kanban_boards_list = _resolveComponent("kanban-boards-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_workspace_title, {
          class: "p-0 title",
          "title-styles": { color: 'var(--light-clr-1)' },
          title: 'Trello workspace',
          subtitle: "Free"
        }, null, 8, ["title-styles"]),
        _createElementVNode("img", {
          class: "kanban-menu-close rounded-1",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('toggleSider')), ["stop"])),
          src: _imports_0,
          alt: "chevron-left"
        })
      ]),
      _hoisted_4,
      _createVNode(_component_kanban_list, { items: _ctx.menuItems }, null, 8, ["items"]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_kanban_boards_list, {
            items: _ctx.workspace.createdBoards,
            "show-bookmark": true,
            "show-sub-menu": true,
            "board-bg-color": 'rgb(131, 140, 145)'
          }, null, 8, ["items", "board-bg-color"])
        ])
      ])
    ])
  ]))
}